import styled from 'styled-components'

import { helpers } from '../../../styles/theme'

export const EmptyItem = styled.span`
	margin-left: 32px;
	color: ${helpers.color.text};
	opacity: 0.6;
`
